export default __webpack_public_path__ + "static/media/nz.7d3b165d.svg";